export const FxLayer = () => <div id="fx-layer" data-testid="fx-layer" className="fx-layer" />;
